export default __webpack_public_path__ + "static/media/shawwal.cb160fb1.jpg";